import * as angular from "angular";

export class ScreenUtils {
    private readonly $mdMedia: any;
    private readonly $window: any;
    public width: number;
    public height: number;

    constructor($mdMedia: any, $window: any) {
        this.$mdMedia = $mdMedia;
        this.$window = $window;
        this.width = this.$window.innerWidth;
        this.height = this.$window.innerHeight;

        window.addEventListener(
            "resize",
            () => {
                this.width = this.$window.innerWidth;
                this.height = this.$window.innerHeight;
            },
            true
        );
    }

    medScreen(): boolean {
        return this.$mdMedia("sm") || this.$mdMedia("xs");
    }

    medToLargeScreen(): boolean {
        return (
            this.$mdMedia("sm") || this.$mdMedia("xs") || this.$mdMedia("md")
        );
    }

    smallScreen(): boolean {
        return this.$mdMedia("xs");
    }
}

angular.module("vcHelper").service("ScreenUtils", ScreenUtils);
